export const HARDWARE_SOURCE_CONFIGS_STR: string = '[["RIPPLE",{"sensorTypes":["PNG"],"supportIncompleteCapture":false,"supportPCDImageViewing":false,"supportedRegions":["IAD","Gamma"]}]]';
